__webpack_require__.p = "/apps/groupfolders/js/";